export enum MyCareRoutes {
  MY_CARE_HUB = 'myCareHub',
  MY_CARE_OTHER_SERVICES = 'myCareOtherServices',
  MY_CARE_ASSESMENT_RESULTS = 'myCareAssessments',
  BOOK_APPOINTMENT = 'bookAppointment',
  CHAT = 'tmhChat',
}
